import React from "react";

import { Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

import AboutBranches from "../about-branches";
import { CopyButton } from "../../copy-button";
import { useTranslation } from "localization/translation";

const CodeRow = ({ value, onEdit }) => (
  <div className="branch_count">
    <p className="font-size-sm user_info_text">{value || "N/A"}</p>
    <div className="d-flex align-items-center">
      {value ? <CopyButton text={value} /> : null}
      <Button
        className="btn-neutral-first mx-1 shadow-none d-30 border-0 p-0 d-inline-flex align-items-center justify-content-center"
        onClick={onEdit}
      >
        <EditIcon color="primary" />
      </Button>
    </div>
  </div>
);

const AboutCompany = (props) => {
  const {
    businessAddress,
    taxCode,
    promoCode,
    dealerCode,
    ambassadorCode,
    branches,
    remaining_branches,
    setIsBranchCountMode,
    setIsPromoCodeMode,
    setIsDealerCodeMode,
    setIsAmbassadorCodeMode,
    contractNumber,
    setIsContractNumberMode,
  } = props;

  const translation = useTranslation();

  return (
    <div className="about_company pr-4 pl-4">
      <div className="font-size-lg mr-3 font-weight-bold">{translation.company_information}</div>
      <div className="informative_section">
        <div className="informative_title">
          <p className="font-weight-bold user_info_text">{translation.address}</p>
          <p className="font-weight-bold user_info_text">{translation.tax_code}</p>
          <p className="font-weight-bold user_info_text">{translation.dealer_code}</p>
          <p className="font-weight-bold user_info_text">{translation.ambassador_code}</p>
          <p className="font-weight-bold user_info_text">{translation.promo_code}</p>
          <p className="font-weight-bold user_info_text">{translation.contract_number}</p>
        </div>
        <div className="informative_text">
          <p className="font-size-sm user_info_text">{businessAddress}</p>
          <p className="font-size-sm user_info_text">{taxCode}</p>
          <CodeRow value={dealerCode} onEdit={() => setIsDealerCodeMode(true)} />
          <CodeRow
            value={ambassadorCode}
            onEdit={() => setIsAmbassadorCodeMode(true)}
          />
          <CodeRow value={promoCode} onEdit={() => setIsPromoCodeMode(true)} />
          <CodeRow
            value={contractNumber}
            onEdit={() => setIsContractNumberMode(true)}
          />
        </div>
      </div>
      <AboutBranches
        branches={branches}
        remaining_branches={remaining_branches}
        setIsBranchCountMode={setIsBranchCountMode}
      />
    </div>
  );
};

export default AboutCompany;
